import React from 'react'
import styles from './registryMatches.module.scss'

const notFoundIcon = require('../icons/notFoundIcon.svg')

export const NoRegistryMatchesFound = () => {
  return (
    <div className={styles.noMatchesContainer}>
      <div className={styles.noMatchesIconWrapper}>
        <img src={notFoundIcon} alt='No matches found' className={styles.noMatchesIcon} />
      </div>
      <h3 className={styles.noMatchesTitle}>No Registry Matches Found</h3>
      <p className={styles.noMatchesDescription}>
        We searched official business registries but couldn&apos;t find any matches for the collected business names and
        addresses. This could mean the business is not formally registered, or it may be registered under a different
        name.
      </p>
    </div>
  )
}
